import {useQuery} from '@apollo/react-hooks';
import {Subset} from '@wandb/weave/common/types/base';
import {notEmpty} from '@wandb/weave/common/util/obj';
import gql from 'graphql-tag';
import {useMemo} from 'react';

import * as Generated from '../../generated/graphql';
import {Graph, ProjectField} from '../../types/graphql';
import * as Run from '../../util/runs';

export const RUN_KEYS = gql`
  query RunKeys(
    $entityName: String!
    $projectName: String!
    $types: [String!] = ["number", "string", "boolean", "other"]
    $limit: Int = 1000
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      name
      fields(
        types: $types
        columns: ["config", "summary_metrics", "system_metrics"]
        first: $limit
      ) {
        edges {
          node {
            path
          }
        }
      }
    }
  }
`;

export interface RunKeysData {
  project: {
    id: string;
    name: string;
    fields: Graph<Subset<ProjectField, 'path'>>;
  };
}

export function useRunKeysQuery(queryVars: Generated.RunKeysQueryVariables) {
  const {loading, data} = useQuery<
    RunKeysData,
    Generated.RunKeysQueryVariables
  >(Generated.RunKeysDocument, {
    fetchPolicy: 'cache-and-network',
    variables: queryVars,
  });

  const fields = useMemo(
    () => data?.project.fields.edges.map(e => e.node) ?? [],
    [data]
  );

  const keys = useMemo(() => {
    return fields
      .map(f => Run.serverPathToKeyString(f.path))
      .filter(notEmpty)
      .filter(k => !k.startsWith('config:_wandb'))
      .sort();
  }, [fields]);

  if (loading) {
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    return {loading: true as true};
  }
  // eslint-disable-next-line @typescript-eslint/prefer-as-const
  return {loading: false as false, keys};
}
